import quickregistryform from './quickregistry-form'

(function($) {  

  const urlParams = new URLSearchParams(window.location.search)   
  const showreg = urlParams.get('showreg')
  if(showreg) { 

    setTimeout(() => {
      
      $('<div class="xoo-el-reg-tgr"></div>').appendTo("body").click();

    }, 500)
  }  

  const quickreg = urlParams.get('quickreg')
  if(quickreg) { 

    fetch(
      '/wp-json/academy/userdata/langandcountrylist',
      {
        method: 'GET',
        headers: {
          'X-WP-Nonce': academy_web_site.nonce
        }
      }
    ) 
    .then(response => {
      
      response.json()
      .then(lists => {

        $('html').css('overflow', 'hidden')
        $('body').addClass('QuickRegistry')
        $('body').append(quickregistryform({
          languages: lists.languages,
          countries: lists.countries
        }))

        const $quickregistry = $('#QuickRegistry .QuickRegistry') 
        const $quickregistryform = $quickregistry.find('.QuickRegistryForm') 
        const $form = $quickregistryform.find('form') 
        const $formresults = $quickregistryform.find('.FormResults')
        const $submit = $quickregistryform.find('.Submit')
        $submit
        .on(
          'click',
          function() {

            const email = $form.find('input[name="email"]').val()
            const language = $form.find('select[name="language"]').val()
            const country = $form.find('select[name="country"]').val()

            if(
              !email
              ||
              !language
              ||
              !country
            ) {

              $formresults.html(__('All fields are required'))
              $formresults.show()

            } else {

              const regex = /^([_\-\.0-9a-zA-Z]+)@([_\-\.0-9a-zA-Z]+)\.([a-zA-Z]){2,7}$/;
              const test = regex.test(email)

              if(!test) {

                $formresults.html(__('Invalid email'))
                $formresults.show()

              } else {

                $formresults.html(__('Registering') + '...')
                $submit.hide()
                $formresults.show()                  
          
                fetch(
                  '/wp-json/academy/userdata/quickregistry',
                  {
                    method: 'POST',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      'X-WP-Nonce': academy_web_site.nonce
                    },
                    body: JSON.stringify({
                      event: quickreg,
                      email: email,
                      language: language,
                      country: country
                    })
                  }
                )
                .then(
                  response => {

                    response.json()
                    .then(
                      result => {

                        if(result.result == 'ok') {

                          $quickregistryform.html(__(`quickregister_thanks`))

                        } else {

                          $formresults.html(__(result.reason))
                          $submit.show()
                        }
                      }
                    )
                  }
                )      
              }   
            }
          }
        )      

        // const $close = $('#QuickRegistry .Overlay, #QuickRegistry .QuickRegistryForm .Close')
        const $close = $('#QuickRegistry .QuickRegistry .Close')
        $close
        .on(
          'click',
          function() {

            $('html').css('overflow', 'inherit')
            $('body').removeClass('QuickRegistry')
            $('#QuickRegistry').remove()
          }
        )
      })
    })
  }
})(jQuery)